// import { useEffect, useMemo, useState } from "react";

// type DeviceType = "mobile" | "tablet" | "desktop";

// function useDeviceType(): DeviceType {
//     const getDeviceType = (): DeviceType => {
//         if (window.innerWidth < 768) {
//             return "mobile";
//         }

//         if (window.innerWidth < 1200) {
//             return "tablet";
//         }

//         return "desktop";
//     };

//     const [deviceType, setDeviceType] = useState<DeviceType>(() =>
//         typeof window === "undefined" ? "desktop" : getDeviceType()
//     );

//     useEffect(() => {
//         const handleResize = () => {
//             setDeviceType(getDeviceType());
//         };

//         window.addEventListener("resize", handleResize);

//         return () => {
//             window.removeEventListener("resize", handleResize);
//         };
//     }, []);

//     return deviceType;
// }

// export default useDeviceType;

import { useSyncExternalStore } from "react";

export type DeviceType = "mobile" | "tablet" | "desktop";

const MOBILE_BREAKPOINT = 768;
const TABLET_BREAKPOINT = 1200;

const getDeviceType = (): DeviceType => {
    if (typeof window === "undefined") {
        return "desktop";
    }

    if (window.innerWidth < MOBILE_BREAKPOINT) {
        return "mobile";
    }

    if (window.innerWidth < TABLET_BREAKPOINT) {
        return "tablet";
    }

    return "desktop";
};

let currentDeviceType: DeviceType = getDeviceType();
const listeners = new Set<() => void>();
let isResizeListenerAttached = false;

const handleResize = () => {
    const nextDeviceType = getDeviceType();

    if (nextDeviceType === currentDeviceType) {
        return;
    }

    currentDeviceType = nextDeviceType;

    listeners.forEach(listener => listener());
};

const subscribe = (listener: () => void) => {
    listeners.add(listener);

    if (!isResizeListenerAttached && typeof window !== "undefined") {
        window.addEventListener("resize", handleResize);
        isResizeListenerAttached = true;
    }

    return () => {
        listeners.delete(listener);

        if (
            listeners.size === 0 &&
            isResizeListenerAttached &&
            typeof window !== "undefined"
        ) {
            window.removeEventListener("resize", handleResize);
            isResizeListenerAttached = false;
        }
    };
};

const getSnapshot = (): DeviceType => currentDeviceType;

const getServerSnapshot = (): DeviceType => "desktop";

const useDeviceType = (): DeviceType => {
    return useSyncExternalStore(
        subscribe,
        getSnapshot,
        getServerSnapshot
    );
};

export default useDeviceType;